import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle, Grid, makeStyles, IconButton, Box } from '@material-ui/core';
import { yellow } from '@material-ui/core/colors';
import ClearIcon from '@material-ui/icons/Clear';
import './servicePointDialog.scss';
import { Tab, Tabs } from '@material-ui/core';
const useStyles = makeStyles({
  dialog: {
    backgroundColor: '#FFCC00F2',
    minHeight: 200,
  },
  Paper: {
    maxWidth: 1000,
  },
});

const ServicePointDialog = (props) => {
  const classes = useStyles();
  const { onClose, selectedValue, open, title, maxWidth, CustomDataTable ,CustomMapData } = props;
  const [activeTab, setActiveTab] = useState(0);

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleTabChange = (event, newValue) =>{
    setActiveTab(newValue)
  }
  return (
    <Dialog
      onClose={handleClose}
      disableBackdropClick={true}
      fullWidth={true}
      maxWidth={maxWidth}
      aria-labelledby="simple-dialog-title"
      BackdropProps={{ style: { backgroundColor: 'rgba(255,203,0,1)', opacity: 0.95 } }}
      open={open}
      className={`DialogContainer ${props.className}`}
    >
      <DialogTitle id="simple-dialog-title">
        <Grid container spacing={3} direction="row" justify="space-between" alignItems="flex-start">
          <Grid item className="dialogTitle">
            {title}
          </Grid>
          <Grid item>
            <IconButton id='closeButton' onClick={handleClose}>
              <ClearIcon className="clearButton" />
            </IconButton>
          </Grid>
        </Grid>
        <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label= "Map View"/>
        <Tab label= "List View"/>
        </Tabs>
      </DialogTitle>
        <DialogContent className="dialogContent">
        <Box class='BoxContent' p={2}>
    {activeTab === 0 &&  CustomMapData}
    {activeTab === 1 && CustomDataTable}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

ServicePointDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  CustomDataTable: PropTypes.element.isRequired,
  CustomMapData: PropTypes.element.isRequired,
  title: PropTypes.string,
};
ServicePointDialog.defaultProps = {
  maxWidth: 'md',
  title: 'Service Point',
};

export default ServicePointDialog;
